import { render, staticRenderFns } from "./ClientsSettingsAe.vue?vue&type=template&id=0a100ae0&"
import script from "./ClientsSettingsAe.vue?vue&type=script&lang=js&"
export * from "./ClientsSettingsAe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports